import React, { PropsWithChildren } from "react";
import { Typography } from "@mui/material";

interface FormLabelProps {
  description?: string;
  required?: boolean;
}

export const FormLabel: React.FC<PropsWithChildren<FormLabelProps>> = ({
  children,
  description,
}) => {
  return (
    <>
      <Typography variant="subtitle1">{children}</Typography>
      <Typography variant="subtitle1" fontSize={"0.8rem"}>
        {description}
      </Typography>
    </>
  );
};
